import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { Template, TemplateCreateInput } from "@wcp/shared";
import { ApiError, apiFetch } from "../../lib/api.js";

/** Templates are WABA-shared, so the query key is global (not business-scoped). */
export function useTemplates() {
  return useQuery<Template[]>({
    queryKey: ["templates"],
    queryFn: async () => {
      const r = await apiFetch<{ templates: Template[] }>("/api/v1/templates");
      return r.templates;
    },
  });
}

export interface TemplateRuleFailure {
  details: string[];
}

export function useCreateTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: TemplateCreateInput) => {
      try {
        return await apiFetch<{ id: number; status: string }>("/api/v1/templates", {
          method: "POST",
          body: JSON.stringify(body),
        });
      } catch (err) {
        if (err instanceof ApiError && err.status === 422) {
          throw err; // server-side rule failure; surfaced by the modal
        }
        throw err;
      }
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["templates"] }),
  });
}
